<template>
  <div class="committees">
    <Committee 
    v-for="committee in committees"
    v-bind:key="committee.id"
    v-bind:name="committee.name"
    v-bind:about="committee.about"
    v-bind:email="committee.email"
    />
  </div>
</template>
<script>
import Committee from '../components/Committee'
import rest from "../rest";
export default {
  name: "committees",
  components:{
    Committee
  },
  data() {
    return {
      committees: null
    };
  },
  mounted() {
    rest.committees().then((response) => {
        this.committees = response.data.data;
    })
  }
};
</script>